// src/pages/Proposals/FileDialog/forms/common/TechniqueSelect.js
import React from "react";
import PropTypes from "prop-types";
import EntitySelect from "../common/EntitySelect";

function TechniqueSelect({
  value,
  onChange,
  label = "technique",
  sx,
  required = false,
  error = false,
  helperText = "",
  highlighted = false,
}) {
  return (
    <EntitySelect
      multiple
      value={value}
      onChange={onChange}
      endpoint="/technique/"
      label={label}
      getOptionLabel={(opt) => opt?.name || ""}
      searchParam="search"
      sx={{
        ...sx,
        ...(highlighted && {
          "& .MuiOutlinedInput-root": {
            backgroundColor: "rgba(66, 165, 245, 0.08)", // 💙 fondo celeste suave
          },

          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#90caf9 !important", // borde azul claro
            borderWidth: "2px",
          },

          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#64b5f6",
          },

          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#42a5f5",
            boxShadow: "0 0 0 2px rgba(66, 165, 245, 0.25)",
          },
        }),
      }}
      error={error}
      helperText={helperText}
    />
  );
}
TechniqueSelect.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.oneOf([null]),
  ]),
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  sx: PropTypes.object,
  required: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
};
TechniqueSelect.defaultProps = {
  value: [],
  label: "technique",
  sx: {},
  required: false,
  error: false,
  helperText: "",
};

export default React.memo(TechniqueSelect);
